export default __webpack_public_path__ + "static/media/mobile.6085b56d.jpg";